import React from 'react';
import { type PublicFileUploadProps } from '../../../types/public-props';
import { useFieldProps } from '../../../contexts/field-props-context';
import { AsChildSlot } from '@wix/headless-utils/react';

interface ExplanationTextFileUploadProps {
  className?: string;
  asChild?: boolean;
}

export const ExplanationText = React.forwardRef<
  HTMLDivElement,
  ExplanationTextFileUploadProps
>((props, ref) => {
  const { className, asChild } = props;
  const { explanationText } = useFieldProps<PublicFileUploadProps>();
  if (!explanationText) {
    return;
  }

  return (
    <AsChildSlot ref={ref} asChild={asChild}>
      <p className={className}>{explanationText}</p>
    </AsChildSlot>
  );
});

ExplanationText.displayName = 'FileUpload.Input.ExplanationText';
